import { Auth } from '@aws-amplify/auth';

async function apiFetch(url, options = {}) {
  const session = await Auth.currentSession();
  const token = session.getAccessToken().getJwtToken();

  const { method = 'GET', body, headers = {} } = options;

  const response = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    ...(body !== undefined ? { body } : {}),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    if (errorData?.name === 'TokenExpiredError') {
      // Token expired — handle refresh or redirect here if needed
    }
    const error = new Error(errorData?.message || response.statusText);
    error.response = errorData;
    throw error;
  }

  return response.json();
}

export default apiFetch;
